var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-tips",on:{"click":function($event){_vm.componentData.visible = false}}})}
var staticRenderFns = []

export { render, staticRenderFns }